import React from 'react';
const CertificateCard = ({ info, index }) => {
    const isOdd = index % 2 === 0;
    return (
        <>
            {!isOdd ?
                <div className="col-md-10 my-2">
                    <div
                        className="program-info  certificate-card">
                        <h1>{info?.title1} </h1>
                        <p>{info?.desc}</p>
                    </div>
                </div> :
                <>
                    <div className="col-md-3 my-2"> </div>
                    <div className="col-md-9">
                        <div
                            className="program-info  certificate-card">
                            <h1>{info?.title1} </h1>
                            <p>{info?.desc}</p>
                        </div>
                    </div>
                </>}
        </>
    );
};

export default CertificateCard;